import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Problems() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={5} xl={5} xxl={5} className="my-auto ">
            <h2>
              The <span style={{ color: "#2F55C4" }}>Problem</span>
            </h2>
            <p>
              Due to the sensitive nature of the app, the client wanted Smart ID
              to be the safest, fastest and the easiest way for users to
              authenticate themselves online.
            </p>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto text-center offset-lg-1"
          >
            <StaticImage
              src="../../../images/case-studies/smartID/tek_img_02.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={786}
              height={554}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Problems;
